import { Tooltip } from "~/src/lib/tooltip"
import { domReady } from "../helpers"
import Popper from "popper.js"

const desktopMQ = window.matchMedia("(min-width: 640px)")

domReady(installTooltips)
desktopMQ.addEventListener("change", () => installTooltips())
addEventListener("include-fragment-replace", ({ detail }) => installTooltips(detail.fragment), { capture: true })

function installTooltips(root = document) {
  if (!desktopMQ.matches) return

  for (const element of root.querySelectorAll("[data-tooltip],[data-tooltips] a[title]")) {
    Tooltip.install(element)
  }

  for (const element of root.querySelectorAll("[data-popover]")) {
    new Popper(element, element.querySelector("[data-popover-content]"), { placement: "top" })
  }
}
